module.exports = __webpack_public_path__ + "img/img7.6260263f.jpg";